import { render, staticRenderFns } from "./ReportQuestion.vue?vue&type=template&id=b1d3004a&"
import script from "./ReportQuestion.vue?vue&type=script&lang=js&"
export * from "./ReportQuestion.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports